import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	CancelFileByIdMutation,
	CancelFileByIdMutationVariables,
} from "~/types/__generated/gql/graphql";
import { getProcessesQueryKey } from "../useGetProcesses";

const query = /* GraphQL */ `
	mutation CancelFileById($id: ObjectID!) {
		cancelFileById(id: $id) {
			_id
		}
	}
`;

export type CancelFileByIdVariables = CancelFileByIdMutationVariables;
export type CancelFileByIdResults = CancelFileByIdMutation["cancelFileById"];

export const useCancelFileById = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: CancelFileByIdVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.cancelFileById),
		onSuccess: () => {
			void queryClient.invalidateQueries(getProcessesQueryKey());
		},
	});
};
